import type { UI } from '@/v2/types';
import { Box, Container, Disclosure, Text } from '@qga/roo-ui/components';

import htmlToReact from '@shared/v2/utils/htmlToReact';

interface HotelPoliciesProps {
  propertyContent: UI.Property;
}

const HotelPolicies = ({ propertyContent }: HotelPoliciesProps) => (
  <Container>
    <Disclosure headerTitle="Hotel policies" expand variant="large">
      <Box width={[null, null, '75%']}>
        <Text fontSize={['sm', null, 'base']}>
          {htmlToReact(propertyContent.propertyPolicies)}
        </Text>
      </Box>
    </Disclosure>
  </Container>
);

export default HotelPolicies;
